import Vue from 'vue';
import gsap from 'gsap';

Vue.mixin({
  created: function () {
    this.gsap = gsap;
  }
});